// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1KDqoHTpLqMWqAyptfxdcl {\n  border-radius: 3px;\n  border: 1px solid #87CEFA;\n  background: rgba(135,206,250, 0.05);\n  margin: 2px 0;\n  padding: 0.5em;\n}\n", ""]);
// Exports
exports.locals = {
	"display": "_1KDqoHTpLqMWqAyptfxdcl"
};
module.exports = exports;
